export const getUrlSearchParams = (): URLSearchParams | null => {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search);
};
